import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared-module/shared/shared.module';
import { CardIntegrationComponent } from './card-integration.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [CardIntegrationComponent],
  exports: [CardIntegrationComponent]
})
export class CardIntegrationModule {}


// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/services/date-time/card-integration/card-integration.module.ts